// Campo da LIA no header: frases que se escrevem no placeholder; no foco, convite fixo.
// "Conversar com a LIA" e Enter no campo abrem a LIA de tela cheia (./LiaFs.js); focar o campo não abre.
const LiaFs = require('./LiaFs');

const Lia = function () {

    const FRASES = [
        'Vou te ajudar a organizar melhor os seus tickets',
        'Te aviso quando um cliente estiver esperando demais',
        'Encontro as oportunidades que pararam de andar',
        'Resumo o seu dia inteiro em uma frase',
        'Conto como foi a última campanha',
        'Mostro o que vendeu mais, e o que encalhou',
        'Aviso quando um pedido trava na importação',
    ];
    const FOCO = 'Pode perguntar. Eu respondo.';

    let input = null;
    let i = 0, n = 0, apagando = false, timer = null, focado = false;

    const passo = function () {
        if (focado) return;
        const f = FRASES[i];
        n += apagando ? -1 : 1;
        input.placeholder = f.slice(0, n);
        let espera = apagando ? 18 : 45;
        if (!apagando && n === f.length) { apagando = true; espera = 1500; }
        else if (apagando && n === 0) { apagando = false; i = (i + 1) % FRASES.length; espera = 400; }
        timer = setTimeout(passo, espera);
    };

    return {
        init: function () {
            input = document.getElementById('o_lia_input');
            if (!input) return;
            input.addEventListener('focus', () => { focado = true; clearTimeout(timer); input.placeholder = FOCO; });
            input.addEventListener('blur', () => { focado = false; n = 0; apagando = false; passo(); });
            passo();

            // O header está dentro de <form method="get"> em product/list: o Enter SEMPRE leva preventDefault,
            // senão a submissão implícita recarrega a página (LICOES da feature, 7).
            // O campo só é limpo depois que o texto está a salvo no modal (bolha ou campo do modal).
            const abrirLia = (origem) => { if (LiaFs.abrir(origem, input.value)) input.value = ''; };
            input.addEventListener('keydown', e => {
                if (e.key !== 'Enter' || e.isComposing) return;
                e.preventDefault();
                abrirLia(input);
            });
            const btn = input.parentNode ? input.parentNode.querySelector('.btn-ask') : null;
            if (btn) btn.addEventListener('click', () => abrirLia(btn));
        }
    };
}();

module.exports = Lia;
